import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResultsPage from '../components/ResultsPage';
import { usePortfolio } from '../context/PortfolioContext';
import { useAuth } from '../context/AuthContext';
import PageOnboarding from '../components/PageOnboarding';

const RESULTS_ONBOARDING_STEPS = [
  {
    title: 'Your Optimized Portfolio',
    message: 'Here are your results! The pie chart shows the recommended allocation for each fund based on your optimization goals.',
  },
  {
    title: 'Performance Metrics',
    message: 'Review key metrics like Expected Return, Risk (Volatility), and Sharpe Ratio. Higher Sharpe means better risk-adjusted returns.',
  },
  {
    title: 'Next Steps',
    message: 'Click "Run Backtest" to see how this portfolio would have performed historically, or download a PDF report.',
  },
];

const ResultsPageWrapper = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const {
    optimizationResults,
    navData,
    selectedFunds,
    startOver,
    markStepCompleted,
  } = usePortfolio();

  const handleRunBacktest = () => {
    markStepCompleted(3);
    navigate('/backtest');
  };

  if (!optimizationResults) {
    return (
      <div className="container page-container">
        <div className="page-header">
          <h2>No Results Available</h2>
          <p>Please run optimization first</p>
        </div>
        <div className="page-actions">
          <button className="btn-next" onClick={() => navigate('/select')}>
            Go to Fund Selection
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <ResultsPage
        results={optimizationResults}
        navData={navData}
        selectedFunds={selectedFunds}
        onStartOver={startOver}
        onGoBack={() => navigate('/optimize')}
        onRunBacktest={handleRunBacktest}
      />
      <PageOnboarding
        pageId="results"
        userEmail={user?.email}
        steps={RESULTS_ONBOARDING_STEPS}
      />
    </>
  );
};

export default ResultsPageWrapper;
